module.exports = __webpack_public_path__ + "static/img/8.7c10e73f.jpg";